import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownSm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.26052 5.24875L6.99718 7.51208L4.73385 5.24875C4.50635 5.02125 4.13885 5.02125 3.91135 5.24875C3.68385 5.47625 3.68385 5.84375 3.91135 6.07125L6.58885 8.74875C6.81635 8.97625 7.18385 8.97625 7.41135 8.74875L10.0888 6.07125C10.3163 5.84375 10.3163 5.47625 10.0888 5.24875C9.86135 5.02708 9.48802 5.02125 9.26052 5.24875Z",
		fill: "#1D1D1D"
	})
});
export default SvgDownSm;
